import React from 'react';
import { Link, Text } from '@common/components';
import { buildDialogUrl } from '@common/services';

export const DisputeReviewLink = ({ disputeCode }: { disputeCode: string }) => {
  const disputeViewDrawerUrl = buildDialogUrl('dispute-view-drawer', {
    props: { action: 'review', disputeCode },
  });

  return (
    <Link to={disputeViewDrawerUrl}>
      <Text weight="bold" color="elm">
        {disputeCode}
      </Text>
    </Link>
  );
};
